import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { StackedListCell } from './StackedList.Cell/StackedList.Cell.es.js';
import { StackedListItem } from './StackedList.Item/StackedList.Item.es.js';

const StackedList = ({ className, headers, children, inactive })=>{
    const justifyClassName = useCallback((justifySelf)=>{
        switch(justifySelf){
            case 'start':
                return 'justify-self-start';
            case 'center':
                return 'justify-self-center';
            case 'end':
                return 'justify-self-end';
            case undefined:
                return undefined;
        }
    }, []);
    return jsxs("div", {
        className: classNames('cb-stacked-list', className),
        children: [
            headers && jsx("div", {
                className: "headers",
                children: headers.map(({ value, justifySelf }, index)=>jsx("p", {
                        className: justifyClassName(justifySelf),
                        children: value
                    }, `${value}-${index}`))
            }),
            jsx("div", {
                className: classNames('body', {
                    inactive: inactive
                }),
                "data-testid": "body",
                children: jsx("ul", {
                    children: children
                })
            })
        ]
    });
};
StackedList.displayName = 'StackedList';
StackedList.Item = StackedListItem;
StackedList.Cell = StackedListCell;

export { StackedList, StackedList as default };
//# sourceMappingURL=StackedList.es.js.map
